import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SizeProps } from '../avatar/avatar.styles';
import { TextSize } from '../text';

export const groupStyles = css`
  display: flex;
  align-items: center;
`;

type AvatarStylesProps = {
  size: SizeProps;
  borderColor?: string;
};

export const SIZE_MAP: Record<
  SizeProps,
  { overlapSpacing: number; borderWidth: number; textSize: TextSize; textSpacing: number }
> = {
  xxs: { overlapSpacing: -0.5, borderWidth: 2, textSize: 'small', textSpacing: 0.5 },
  xs: { overlapSpacing: -1, borderWidth: 2, textSize: 'small', textSpacing: 0.75 },
  small: { overlapSpacing: -1.25, borderWidth: 3, textSize: 'medium', textSpacing: 1 },
  medium: { overlapSpacing: -1.5, borderWidth: 3, textSize: 'medium', textSpacing: 1.25 },
  large: { overlapSpacing: -2, borderWidth: 3, textSize: 'large', textSpacing: 1.5 },
  xl: { overlapSpacing: -2.5, borderWidth: 4, textSize: 'large', textSpacing: 1.5 },
  xxl: { overlapSpacing: -2.5, borderWidth: 4, textSize: 'large', textSpacing: 1.5 },
};

export const avatarStyles = ({ size, borderColor }: AvatarStylesProps) => {
  const { overlapSpacing, borderWidth } = SIZE_MAP[size];

  return css`
    outline: ${borderWidth}px solid ${borderColor || theme.colors.white};
    border-radius: ${theme.borderRadius.full};
    margin-left: ${theme.spacing(overlapSpacing)};
  `;
};

export const firstAvatarStyles = ({ size, borderColor }: AvatarStylesProps) => {
  const { borderWidth } = SIZE_MAP[size];

  return css`
    outline: ${borderWidth}px solid ${borderColor || theme.colors.white};
    border-radius: ${theme.borderRadius.full};
  `;
};

export const textStyles = ({ size }: AvatarStylesProps) => {
  const { textSpacing } = SIZE_MAP[size];

  return css`
    margin: ${theme.spacing(0, 0, 0, textSpacing)};
    user-select: none;
  `;
};

export const tooltipContentStyles = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
  span {
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    p {
      margin: 0;
    }
  }
`;

export const AvatarGroupStyles = {
  group: groupStyles,
  avatar: (props: AvatarStylesProps) => avatarStyles(props),
  firstAvatar: (props: AvatarStylesProps) => firstAvatarStyles(props),
  text: (props: AvatarStylesProps) => textStyles(props),
  tooltipContent: tooltipContentStyles,
};
